module.exports = __webpack_public_path__ + "static/media/Frame 324.7b4bdee5.png";